import { Flex } from "@chakra-ui/react";
import { NewHireJourney } from "models/v2/newHireJourney";
import { TaskSummary } from "features/Resources/Task/models";
import HeaderIdentityCard from "./HeaderIdentityCard";
import HeaderTaskProgressCard from "./HeaderTaskProgressCard";
import HeaderStageCard from "./HeaderStageCard";

interface ManagerNewHireHeaderProps {
  newHireJourney: NewHireJourney | undefined;
  tasks?: TaskSummary[];
  canEditDetails?: boolean;
}

export default function ManagerNewHireHeader({ newHireJourney, tasks, canEditDetails = false }: ManagerNewHireHeaderProps) {
  if (!newHireJourney) return null;

  return (
    <Flex gap={4} flexWrap="wrap" align="stretch">
      <HeaderIdentityCard newHireJourney={newHireJourney} canEditDetails={canEditDetails} />
      <HeaderTaskProgressCard newHireJourneyId={newHireJourney.id} tasks={tasks} />
      <HeaderStageCard newHireJourney={newHireJourney} />
    </Flex>
  );
}
